import styled from "styled-components";
import theme from "../../styles/theme";
import Status from "../../types/enum/Status";
import Button from "../../components/Button";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { ClickableIcon } from "../../components/Icon";
import Modal from "../../components/Modal";
import { Icon } from "@mui/material";
import Card from "../../components/Card";
import { StyledText, TextSize, TextStatus } from "../../components/Text";
import { RightAlign } from "../../components/UtilsComponents";
import NormalIcon from "../../components/Icon";
import moment from "moment";

const SkillCompleted = styled(Card)`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;

  position: relative;
  width: auto;
  height: auto;
  min-height: 190px;
  left: 0px;
  top: 0px;

  /* Dark outline transparent */

  background: rgba(0, 0, 0, 0.3);
  // border: 2px solid #36eab9;
  // box-shadow: 0px 4px 35px #54c2ab;
  backdrop-filter: blur(40px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 10px;

  /* Inside auto layout */

  // flex: none;
  order: 0;
  // flex-grow: 0;
  // margin: 0px 20px;
  cursor: pointer;
`;
type EvaluationModalProps = {
  isOpen: boolean;
  setOpen: (x: boolean) => void;
  confirmFunction?: () => void;
  pdfBlob: any;
};
const Title = styled.div`
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  display: flex;
`;
const StyledHr = styled.hr`
  width: 100%;
  border-color: #3c406c;
  margin-top: 16px;
  margin-bottom: 16px;
`;
const PreviewModal = ({
  pdfBlob,
  isOpen,
  setOpen,
}: EvaluationModalProps): JSX.Element => {
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Modal
        onDismiss={() => handleClose()}
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: { zIndex: "99900" },
          content: {
            marginTop: 20,
            maxHeight: "90vh",
            maxWidth: "90vw",
            padding: "0 16px 24px 16px",
            background: "#090d20",
            boxShadow: "0 0 14px black",
          },
        }}
      >
        <FlexBox
          style={{ display: "flex", justifyContent: "end", padding: 10 }}
        >
          <ClickableIcon name="times" onClick={() => setOpen(false)} />
        </FlexBox>
        <iframe
          src={URL.createObjectURL(pdfBlob)}
          title="PDF Preview"
          width="100%"
          height="1200px"
          style={{ border: "1px solid #ccc", marginTop: "20px" }}
        />
      </Modal>
    </>
  );
};

export default PreviewModal;
